import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="errors-content">
      <div className="errors-body">
        <div className="errors-title">404</div>
        <div className="errors-desc">Страница не найдена</div>
      </div>

      <Link to={`/`} className="at-btn at-btn-medium">
        На главную
      </Link>
    </div>
  );
};

export default NotFoundPage;
